import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { getFeature, getModelValue } from '@aytm/app/stats/lib/stat-page'

import { resolveSigtestKeys } from '@aytm/app/stats/page/question-views/cl/components/partial/lib/props'
import { calcPartialProps } from '@aytm/app/stats/page/question-views/tl/components/partial/lib/props'

// components
import { default as CompareItems } from '@aytm/app/stats/page/question-views/info-view/components/compare-items/Block'
import ReloadScreen from '@aytm/app/stats/page/question-views/components/questions-custom/ReloadScreen'

// The tracker-lab partial: the entities being tracked, compared wave by wave. Whole-survey
// tracking has a single batch, so the comparison controls the payload carries switch off with it.
const Block = ({ model, params, paramsRevision, reloadNeeded, onReady, onStateChange, onExport }) => {
  // read per render: the shell redraws on a page-level change without minting a new payload
  const { level, pair } = resolveSigtestKeys()
  const percentDecimals = getModelValue('percentDecimals')

  const props = useMemo(
    () =>
      calcPartialProps({
        id: model.id,
        key: model.key,
        text: model.text,
        answer: model.answer,
        entities: model.entities,
        attributes: model.attributes,
        splitBy: model.splitBy,
        group: model.group,
        keys: { level, pair },
        percentDecimals
      }),
    [model, level, pair, percentDecimals]
  )

  return (
    <>
      <CompareItems
        id={props.key}
        params={params}
        paramsRevision={paramsRevision}
        title=""
        fullScreenTitle={props.title}
        itemName={props.format.itemName}
        format={props.format}
        batches={props.batches}
        answer={props.answer}
        splitBy={props.splitBy}
        percentDecimals={props.percentDecimals}
        footer={<>&nbsp;</>}
        showExportButton={true !== getFeature('authorized_exports')?.disabled}
        onReady={onReady}
        onStateChange={onStateChange}
        onExport={onExport}
      />
      <ReloadScreen reloadNeeded={reloadNeeded} />
    </>
  )
}

Block.propTypes = {
  model: PropTypes.object.isRequired,
  params: PropTypes.object,
  paramsRevision: PropTypes.number,
  reloadNeeded: PropTypes.bool,
  onReady: PropTypes.func,
  onStateChange: PropTypes.func,
  onExport: PropTypes.func
}

export default Block
